import { Model } from './Model';
import { Postable } from './Postable';
import { Expose } from 'class-transformer';

export class Organization extends Model implements Postable {

	private _name: string;

	static socratesId = '8c84f853-395d-4882-bad2-728d7ce6a43d';

	constructor(rawOrganization: any) {
		super(rawOrganization);
		this._name = rawOrganization?.name;
		this.originalJson = rawOrganization;
	}

	getSubmissionJson(): any {
		return { name: this._name };
	}

	@Expose()
	set name(name: string) { this._name = name; }
	get name(): string { return this._name; }
}
